import React, { useEffect, useState } from "react";
// import Tabs from './tabs';
import "./css.css";
import img1 from "../img/ADI_1D.png";
import img2 from "../img/ADI_1M.png";
import img3 from "../img/ADI_1Y.png";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";

import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function
 **/

export const Page2 = (props) => {
  const [pic, setPic] = useState(img1);
  const [estimation, setConfidence] = useState(true);
  const history = useNavigate();
  const [url, setUrl] = useState(window.location.href);
  const [userId, setUserId] = useState("");
  const [key, setKey] = useState('page2_1D');
  const [selectedValue, setSelectedValue] = useState(50);
  const [isRangeMoved, setIsRangeMoved] = useState(false);

  const handleRangeChange = (event) => {
    setSelectedValue(event.target.value);
  };

  async function addclick(data) {
    console.log(data);
    const docRef = await addDoc(collection(db, "clicksdata"), {data,});
  }

  const submit = async () => {
    console.log(selectedValue);
    localStorage.setItem("page2_confidence",selectedValue);
    const page2_confidence_button = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: "page2_confidence_button",
    };
    history(`/page2A/?,${userId}`);
    addclick(page2_confidence_button);
  }

  const button = async (eventKey) => { 
    setKey(eventKey)
    const clickdata = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: eventKey
    };
    addclick(clickdata);
    if (eventKey === "page2_1D") {
      setPic(img1);
    }
    if (eventKey === "page2_1M") {
      setPic(img2);
    }
    if (eventKey === "page2_1Y") {
      setPic(img3);
    }
  }  

  useEffect(() => {
    const iosa = url.split(",");
    setUserId(iosa[1]);
  }, []);

  return (
    <div className="main">
      <div className="header">
        <h1>CORPORATION X</h1>
        <h3>Current Price: 118.57 USD</h3>
      </div>
      <div className="grid">
        <div className="webtabs">
          <Tabs
            defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3" activeKey={key}
            onSelect={(e) => button(e)}
          >
            <Tab eventKey="page2_1D" title="1D">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page2_1M" title="1M">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page2_1Y" title="1Y">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page2_details" title="Details">
              {/* <img className="img1" src={pic} alt="" /> */}
              <table class="table table-hover table-dark table-striped">
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>Open</td>
                    <td>116.23</td>
                    <td>Beta</td>
                    <td>2.43</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>High</td>
                    <td>118.89</td>
                    <td>Avg Volume</td>
                    <td>2135330</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Low</td>
                    <td>116.07</td>
                    <td>Market Cap</td>
                    <td>234668422.53</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Close</td>
                    <td>118.57</td>
                    <td>52 Week High</td>
                    <td>124.79</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Adj Close</td>
                    <td>111.63</td>
                    <td>52 Week Low</td>
                    <td>95.51</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Volume</td>
                    <td>3074300</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="page2_profile" title="Profile">
              {/* <img className="img" src={pic} alt="" /> */}
              <p className="profileinfo"> Sector: Technology <br></br><br></br>
                This tech corporation conceives and fabricates unified circuits, software, and subsystems. <br></br>
                Its products utilize various signal processing technologies that transform analogous signals into numeric digital data and the other way around. <br></br>
                The corporation offers products for power management and reference, radio frequency, and microwave consolidated circuits, high-performance amplifiers, and micro-electro-mechanical systems technology solutions. <br></br>
                It also provides numeric digital data calculation products for digital data processing and systems at high speed. <br></br>
                The corporation's customer base includes various sectors, such as aerospace, automotive, communication, consumer, instrumentation, and industrial markets.
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="info">

        {estimation ? (
            <div class="text-center">
              <div>
                <h1>YOUR INITIAL PREDICTION</h1>
                <p>Based on the information available, what is your prediction of the stock's price, in $, exactly one month later?
                </p>
              </div>
              <Formik
                initialValues={{ page2_prediction: "" }}
                onSubmit={(values) => {
                  console.log(values.page2_prediction);
                  localStorage.setItem("page2_prediction", values.page2_prediction);
                  const page2_prediction_button = {
                    time: Date.now(),
                    userId: localStorage.getItem("user_id"),
                    buttonType: "page2_prediction_button"
                  };
                  addclick(page2_prediction_button);
                  setConfidence(false);
                }}
                validationSchema={Yup.object({
                  page2_prediction: Yup.number().max(10000).min(0).required("prediction is required")
                })}
              >
                {(formik, isSubmitting) => (
                  <Form>
                    <div className="d-flex justify-content-center">
                      <div className="col-sm-4">
                        <Field name="page2_prediction" className={ formik.touched.page2_prediction && formik.errors.page2_prediction ? "form-control is-invalid" : "form-control" } type="text" placeholder="numbers only"/>
                      </div>
                    </div>
                    <br></br>
                    <div class="text-center">
                      <Button variant="dark" className="estbutton" type="submit">Submit</Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div class="text-center">
              <div>
                <h1>YOUR CONFIDENCE LEVEL</h1>
                <p> Please move the marker to indicate how confident you are that your prediction is accurate, from 0 to 100. 
                  <span className="marker_span"><br></br>0- I am definitely wrong.
                  100- I am definitely right. </span><br></br>
                </p>
              </div>
              <Form1.Range name="page2_confidence" value={selectedValue} onChange={handleRangeChange} onInput={() => setIsRangeMoved(true)}/>
              <p>Confidence level: {isRangeMoved ? selectedValue : "none"}</p>
              <Button variant="dark" className="estbutton" type="submit" onClick={submit} disabled={!isRangeMoved}>Submit</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
